



.socials
{
    display: flex;
    gap: 15px;
    align-items: center;

}
